import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'

export default {
  created() {
    window.scrollTo(0, 0)
    const serviceOrder = JSON.parse(sessionStorage.getItem('serviceOrder'))
    if (serviceOrder) {
      this.currentServiceOrder = serviceOrder

      if (this.currentServiceOrder.supplier) {
        this.supplier = this.currentServiceOrder.supplier
        const businessContact =
          this.currentServiceOrder.supplier.businessContact
        const technicalContact =
          this.currentServiceOrder.supplier.technicalContact

        this.supplier.contact =
          technicalContact != ''
            ? technicalContact
            : businessContact != ''
            ? businessContact
            : ''

        const technicalPhoneNumber =
          this.currentServiceOrder.supplier.technicalPhoneNumber
        const technicalCellPhoneNumber =
          this.currentServiceOrder.supplier.technicalCellPhoneNumber
        const businessPhoneNumber =
          this.currentServiceOrder.supplier.businessPhoneNumber
        const businessCellPhoneNumber =
          this.currentServiceOrder.supplier.businessCellPhoneNumber

        this.supplier.phoneNumber =
          technicalCellPhoneNumber != ''
            ? technicalCellPhoneNumber
            : technicalPhoneNumber != ''
            ? technicalPhoneNumber
            : businessPhoneNumber != ''
            ? businessPhoneNumber
            : businessCellPhoneNumber != ''
            ? businessCellPhoneNumber
            : ''

        const supplierAddress =
          this.currentServiceOrder.supplier.address != ''
            ? `${this.currentServiceOrder.supplier.address},`
            : ''
        const supplierLocationNumber =
          this.currentServiceOrder.supplier.locationNumber != null
            ? `nº ${this.currentServiceOrder.supplier.locationNumber}`
            : 'S/N'
        const supplierComplement =
          this.currentServiceOrder.supplier.complement != ''
            ? `${this.currentServiceOrder.supplier.complement},`
            : ''
        const supplierDistrict =
          this.currentServiceOrder.supplier.district != ''
            ? `${this.currentServiceOrder.supplier.district} -`
            : ''

        this.supplier.address =
          `${supplierAddress}${supplierLocationNumber},${supplierComplement}` +
          `${supplierDistrict} ${this.currentServiceOrder.supplier.city}/${this.currentServiceOrder.supplier.state}`
      }

      const unidadeAddress =
        this.currentServiceOrder.unidade.address != ''
          ? this.currentServiceOrder.unidade.address
          : ''
      const unidadeLocationNumber =
        this.currentServiceOrder.unidade.locationNumber != null
          ? `nº ${this.currentServiceOrder.unidade.locationNumber}`
          : 'S/N'
      const unidadeComplemnt =
        this.currentServiceOrder.unidade.complement != ''
          ? `${this.currentServiceOrder.unidade.complement},`
          : ''

      this.unidadeAddress =
        `${unidadeAddress}, ${unidadeLocationNumber}, ${unidadeComplemnt}` +
        `${this.currentServiceOrder.unidade.district} - ${this.currentServiceOrder.unidade.city}/${this.currentServiceOrder.unidade.state}`

      this.currentDate = this.formatDate(new Date())
    }
  },

  data: () => ({
    loading: false,
    currentServiceOrder: {},
    supplier: {
      corporateName: '',
      cnpj: '',
      phoneNumber: '',
      contact: '',
      address: '',
    },
    unidadeAddress: null,
    defectDescription: '',
    descriptionConditions: '',
    currentDate: '',
    authorizationResponsible: '',
    departmentAuthorizationResponsible: '',
    conveyer: '',
    documentConveyer: '',
    apiService: new ApiService(),
  }),

  methods: {
    close() {
      this.$router.push('/serviceOrders')
    },

    formatDate(date) {
      return Utils.moment(date)
    },

    async printExitAuth() {
      this.loading = true

      const exitAuthorization = {
        ServiceOrderNumber: this.currentServiceOrder.number,
        SupplierCorporateName: this.supplier.corporateName,
        SupplierCEP: this.supplier.cep,
        SupplierCnpj: this.supplier.cnpj,
        SupplierPhoneNumber: this.supplier.phoneNumber,
        SupplierContact: this.supplier.contact,
        SupplierAddress: this.supplier.address,
        UnidadeName: this.currentServiceOrder.unidade.name,
        UnidadePhone: this.currentServiceOrder.unidade.phone,
        UnidadeEmail: this.currentServiceOrder.unidade.emailResponsibleToLeave,
        UnidadeCnpj: this.currentServiceOrder.unidade.cnpj,
        UnidadeAddress: this.unidadeAddress,
        EquipmentName: this.currentServiceOrder.equipment.name,
        EquimentIdentification:
          this.currentServiceOrder.equipment.identification,
        EquipmentSerialNumber: this.currentServiceOrder.equipment.serialNumber,
        EquipmentPropertyCode: this.currentServiceOrder.equipment.propertyCode,
        EquipmentManufacturer: this.currentServiceOrder.equipment.manufacturer,
        EquipmentAccessories: this.currentServiceOrder.equipment.accessories,
        EquipmentModel: this.currentServiceOrder.equipment.model,
        EquipmentDefectDescription: this.defectDescription,
        EquipmentDescriptionConditions: this.descriptionConditions,
        ExitDate: this.currentDate,
        AuthorizationResponsible: this.authorizationResponsible,
        DepartmentAuthorizationResponsible:
          this.departmentAuthorizationResponsible,
        Conveyer: this.conveyer,
        DocumentConveyer: this.documentConveyer,
      }

      await this.apiService
        .post('serviceOrder/printExitAuth', exitAuthorization)
        .then((response) => {
          response = 'data:application/pdf;base64,' + response.content.pdf
          const link = document.createElement('a')
          link.href = response
          link.setAttribute(
            'download',
            `Autorizacao_Saida:${this.formatDate(new Date())}`
          )
          document.body.appendChild(link)
          link.click()
        })

      this.loading = false
    },
  },

  watch: {},
}
